
import { initBridgeParent } from "@/helpers/iframeBridge"
import PhoneCard from "@/components/base/card/PhoneCard.vue"
let listener
export default {
    name: "JobPagePhonePreview",
    components: { PhoneCard },
    props: {
        job: {
            type: Object,
            required: true,
        },
        showHeadline: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        listener = initBridgeParent(this.$refs.iframe, this.job)
    },
    beforeDestroy() {
        listener?.unregister()
    },
    methods: {
        onElementFocused(elementIdentifier) {
            if (!this.$refs?.iframe?.contentWindow) return
            const el =
                this.$refs.iframe.contentWindow.document.getElementById(
                    elementIdentifier
                )
            if (!el) return
            el.classList.remove("clickeffect--pulse")
            el.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
            })
            if (this.currentAnimationTimeout) {
                clearTimeout(this.currentAnimationTimeout)
            }
            el.classList.add("clickeffect--pulse")
            this.currentAnimationTimeout = setTimeout(
                () => el.classList.remove("clickeffect--pulse"),
                2000
            )
        },
    },
}
